module.exports = __webpack_public_path__ + "static/media/loading.4f59979c.gif";